<template>
  <button
    :class="buttonStyles"
    :disabled="clickableButton"
    class="transition"
    @click="click($event)"
  >
    <circles-to-rhombuses-spinner
      v-if="loading && !iconOnly"
      :animation-duration="1000"
      :circles-num="3"
      :circle-size="10"
      :color="loaderColor"
      class="m-auto absolute left-0 right-0 bottom-0 top-0 h-4"
    />
    <div class="flex justify-center items-center">
      <FontAwesomeIcon v-if="activeIcon" :icon="icon" :class="iconOnlyButton" />
      <slot v-if="!iconOnly" />
    </div>
  </button>
</template>

<script>
import "epic-spinners/dist/lib/epic-spinners.min.css";
import { CirclesToRhombusesSpinner } from "../../node_modules/epic-spinners/dist/lib/epic-spinners.min.js";

export default {
  name: "Button",
  components: {
    CirclesToRhombusesSpinner
  },
  props: {
    outline: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    iconOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonStyles() {
      return [
        ...this.outlineButton,
        ...this.flatButton,
        ...this.button,
        ...this.disabledButton,
        ...this.loadingButton,
        ...["py-3.5", "px-6", "rounded", "focus:outline-none", "relative"]
      ];
    },
    iconOnlyButton() {
      return this.iconOnly
        ? [
            "m-auto",
            "absolute",
            "left-0",
            "right-0",
            "bottom-0",
            "top-0",
            "h-4"
          ]
        : ["mr-4"];
    },
    loadingButton() {
      return this.loading && !this.iconOnly
        ? ["text-transparent"]
        : ["text-secondary"];
    },
    disabledButton() {
      return this.clickableButton ? ["disabled:opacity-50"] : [];
    },
    outlineButton() {
      return this.outline
        ? ["shadow-inner", "border", "border-solid", "border-secondary"]
        : [];
    },
    flatButton() {
      return this.flat ? [] : [];
    },
    button() {
      return !this.flat && !this.outline
        ? [
            "bg-secondary",
            !this.loading ? "text-white" : "",
            ...this.checkReactivity([
              "hover:bg-secondary-shade-1",
              "active:bg-secondary-shade-2"
            ])
          ]
        : [
            "bg-transparent",
            ...this.checkReactivity([
              "hover:bg-primary-shade-1",
              "active:bg-primary-shade-2"
            ])
          ];
    },
    activeIcon() {
      return this.icon;
    },
    clickableButton() {
      return this.disabled || this.loading;
    },
    loaderColor() {
      return this.flat || this.outline
        ? "var(--color-secondary)"
        : "var(--color-primary)";
    }
  },
  methods: {
    click(event) {
      this.$emit("click", event);
    },
    checkReactivity(reactiveStyles) {
      return this.clickableButton ? ["cursor-default"] : reactiveStyles;
    }
  }
};
</script>

<style scoped>
button {
  transition: background-color 0.15s ease;
}
</style>
